<template>
  <div class="position-relative h-100 w-100">
    <div class="map-header position-absolute text-light">
      <h2 class="h3 m-0"><span>Day 03 - </span>Polygons</h2>
    </div>
    <div ref="map-root" class="basemap"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import AnimatedPopup from "mapbox-gl-animated-popup";
import "mapbox-gl/src/css/mapbox-gl.css";
import polygons from "../assets/polygon.geojson";

export default {
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoia21hcnNoYWxsIiwiYSI6ImNrdXdudGlpODI2ejkydXF2bXcyM3poaWQifQ.hyBCr6uwWlDGMGyVmuKCIw",
      map: null,
      geojson: polygons,
      popup: null,
      activeCountyId: null,
      populationTotal: 0,
    };
  },
  methods: {
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: this.$refs["map-root"],
        style: "mapbox://styles/mapbox/empty-v8",
        center: [-3.92813, 55.45354],
        pitch: 50,
        zoom: 8,
      });

      this.map.on("load", () => {
        this.map.addSource("counties", {
          type: "geojson",
          data: this.geojson,
        });

        // Add a layer showing the state polygons.
        this.map.addLayer({
          id: "counties",
          type: "fill",
          source: "counties",
          paint: {
            "fill-color": [
              "interpolate",
              ["linear"],
              ["get", "population"],
              0,
              "#690275",
              25000,
              "#E402FD",
              50000,
              "#1D02FD",
              100000,
              "#0294FD",
              200000,
              "#02FDC0",
              300000,
              "#0EFD02",
              400000,
              "#EFFD02",
              500000,
              "#FDB602",
              600000,
              "#FD1002",
            ],
            "fill-opacity": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              1,
              0.2,
            ],
          },
        });

        let i = 1;
        const timer = setInterval(() => {
          if (i <= this.geojson.features.length) {
            if (this.activeCountyId !== null) {
              this.map.setFeatureState(
                { source: "counties", id: this.activeCountyId },
                { hover: false }
              );
              if (this.popup !== null) {
                this.popup.remove();
              }
            }
            this.activeCountyId = i;
            this.map.setFeatureState(
              { source: "counties", id: this.activeCountyId },
              { hover: true }
            );

            let activeFeature = this.geojson.features[0];
            if (i > 1) {
              activeFeature = this.geojson.features[i - 1];
            }
            this.map.flyTo({
              center: activeFeature.properties.popupCoordinates,
              speed: 0.1, // make the flying slow
            });
            this.popup = new AnimatedPopup({
              offset: 5,
              openingAnimation: {
                duration: 1000,
                easing: "easeInOutCubic",
              },
              closingAnimation: {
                duration: 500,
                easing: "easeInBack",
              },
              closeButton: false,
            })
              .setLngLat(activeFeature.properties.popupCoordinates)
              .setHTML(
                `
                <strong class="m-0">${activeFeature.properties.name}</strong>
                <p class="m-0">Population: ${activeFeature.properties.population.toLocaleString()}</p>
              `
              )
              .addTo(this.map);
            i++;
          } else {
            window.clearInterval(timer);
          }
        }, 3000);

        // disable map rotation using right click + drag
        this.map.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();
      });

      this.map.scrollZoom.disable();
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/map-shared.scss";
:deep(.mapboxgl-popup-content) {
  color: #191919;
  z-index: 3;
  font-size: 1rem;
  font-family: inherit;
}
</style>
